<template>
  <div>
    <el-table :data="data" border height="100%" style="width: 100%">
      <el-table-column prop="upload_time" label="上传时间">
      </el-table-column>
      <el-table-column label="经度">
        <template slot-scope="scope">
          {{ scope.row.lon?`${scope.row.lon} E`:"无数据" }}
        </template>
      </el-table-column>
      <el-table-column label="纬度">
        <template slot-scope="scope">
          {{ scope.row.lat?`${scope.row.lat} N`:"无数据" }}
        </template>
      </el-table-column>
      <el-table-column label="剩余电量" width="150">
        <template slot-scope="scope">
          <el-progress v-if="scope.row.battery" :text-inside="true" :stroke-width="18" :percentage="scope.row.battery"
            :color="getBatteryStatusColor(scope.row.battery)"></el-progress>
          <div v-else>无数据</div>
        </template>
      </el-table-column>
    </el-table>
    <Pagination totalCountOrURL="/terminal/cnt_heartbeatRd" :params="{device_lgid:lgid}" @change="handlePageChange"></Pagination>
  </div>
</template>

<script>
  import Pagination from "@/components/PageNations/Pagination";
  export default {
    props: ["lgid"],
    components: {
      Pagination
    },
    mounted() {
      this.getData();
    },
    watch: {
      lgid() {
        this.getData();
      }
    },
    data() {
      return {
        data: [],
        page: 1,
        size: 10
      };
    },
    methods: {
      getBatteryStatusColor(percentage) {
        if (!percentage) {
          percentage = 0;
        }
        let cStart = [255, 0, 0];
        let cEnd = [0, 255, 0];
        let r, g, b;
        r = parseInt(cStart[0] + (cEnd[0] - cStart[0]) * percentage / 100);
        g = parseInt(cStart[1] + (cEnd[1] -
          cStart[1]) * percentage / 100);
        r = r <
          0 ? 0 : r;
        r = r > 255 ? 255 : r;
        g = g <
          0 ? 0 : g;
        g = g > 255 ? 255 : g;
        return `rgb(${r},${g},0)`
      },
      handlePageChange(params) {
        this.page = params.page;
        this.size = params.size;
        this.getData();
      },
      getData() {
        if (this.lgid) {
          this.$getJSON("/terminal/s_heartbeatRd", {
            device_lgid: this.lgid,
            page: this.page,
            size: this.size
          }).then(res => {
            this.data = res.data;
          });
        }
      }
    }
  };

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Tables/HeartbeatRd.vue